import Vue from "vue";
import { canView, homePath, isLegacyReadOnly } from "../utils/access";
import VueRouter from "vue-router";
import {
  isAuthenticated,
  removeDataFromLocalStorage,
  getTokenFromLocalStorage,
} from "../api.js";
import axios from "axios";

//pages
import inspection from "../views/inspection/inspection.vue";
import inspectionForm from "../views/inspection/inspectionForm.vue";
import inspectionCategory from "../views/inspection/inspectionCategory.vue";
import inspectionCategoryForm from "../views/inspection/inspectionCategoryForm.vue";
import operatingInstruction from "../views/operatingInstruction/operatingInstruction.vue";
import betriebsanweisungForm from "../views/operatingInstruction/betriebsanweisungForm.vue";
import betriebsanweisungTemplates from "../views/operatingInstruction/betriebsanweisungTemplates.vue";
import betriebsanweisungTemplateList from "../views/operatingInstruction/betriebsanweisungTemplateList.vue";
import instructionCategory from "../views/operatingInstruction/instructionCategory.vue";
import instructionCategoryForm from "../views/operatingInstruction/instructionCategoryForm.vue";
import files from "../views/files/files.vue";
import riskAssessment from "../views/riskAssessment/riskAssessment.vue";
import riskAssessmentForm from "../views/riskAssessment/riskAssessmentForm.vue";
import riskAssessmentCategory from "../views/riskAssessment/riskAssessmentCategory.vue";
import riskAssessmentCategoryForm from "../views/riskAssessment/riskAssessmentCategoryForm.vue";
import DangerousGoodsList from "../views/dangerousGoods/dangerousGoodsList.vue";
import DangerousGoodsListForm from "../views/dangerousGoods/dangerousGoodsListForm.vue";
import DangerousGoodsStorageLocation from "../views/dangerousGoods/dangerousGoodsStorageLocation.vue";
import DangerousGoodsStorageLocationForm from "../views/dangerousGoods/dangerousGoodsStorageLocationForm.vue";
import tickets from "../views/tickets/tickets.vue";
import instructions from "../views/instructions/instructions.vue";
import instructionPublic from "../views/instructions/instructionPublic.vue";
import instructionFolder from "../views/instructions/instructionFolder.vue";
import instructionsHub from "../views/instructions/instructionsHub.vue";
import instructionFolderForm from "../views/instructions/instructionFolderForm.vue";
import proofCategory from "../views/proof/proofCategory.vue";
import proofCategoryForm from "../views/proof/proofCategoryForm.vue";
import proofForm from "../views/proof/proofForm.vue";
import proofs from "../views/proof/proofs.vue";
import employeeGroupTable from "../views/managedInstruction/employee/employeeGroupTable.vue";
import employeeGroupForm from "../views/managedInstruction/employee/employeeGroupForm.vue";
import employeeMain from "../views/managedInstruction/employee/employeeMain.vue";
import managedInstructionAssignmentTable from "../views/managedInstruction/managedInstructionAssignmentTable.vue";
import managedInstructionAssignmentForm from "../views/managedInstruction/managedInstructionAssignmentForm.vue";
import managedInstructionsUserPage from "../views/managedInstruction/userPage.vue";
import managedInstructionDetailsPage from "../views/managedInstruction/managedInstructionDetailsPage.vue";
import examinationDetailsPage from "../views/examination/examationDetailsPage.vue";
import settingsTabs from "../views/settings/settingsTabs.vue";
import boardSettings from "../views/settings/boardSettings.vue";
import emailSettings from "../views/settings/emailSettings.vue";
import multiuserSettings from "../views/settings/multiuserSettings.vue";
import profileSettings from "../views/settings/profileSettings.vue";
import consultingPage from "../views/consulting/consultingPage.vue";
import incidentReport from "../views/incidentReport/incidentReport.vue";
import incidentReportMonths from "../views/incidentReport/incidentReportMonths.vue";
import incidentReportForm from "../views/incidentReport/incidentReportForm.vue";
import incidentReportFormQuick from "../views/incidentReport/incidentReportFormQuick.vue";
import medkitlog from "../views/medkitlog/medkitlog.vue";
import reportsHub from "../views/reports/reportsHub.vue";
import environmentalReportMonths from "../views/environmentalReport/environmentalReportMonths.vue";
import environmentalReportByMonthView from "../views/environmentalReport/environmentalReport.vue";
import environmentalReportForm from "../views/environmentalReport/environmentalReportForm.vue";
import medkitlogMonths from "../views/medkitlog/medkitlogMonths.vue";
import asaMeetingYears from "../views/asaMeeting/asaMeetingYears.vue";
import asaMeetingList from "../views/asaMeeting/asaMeetingList.vue";
import asaMeetingForm from "../views/asaMeeting/asaMeetingForm.vue";
import medkitlogForm from "../views/medkitlog/medkitlogForm.vue";
import usersSettings from "../views/settings/users/usersTable.vue";
import usersForm from "../views/settings/users/usersForm.vue";
import proofersSettings from "../views/settings/proofersSettings.vue";
import incidentReportSettings from "../views/settings/incidentReportSettings.vue";
import personioSettings from "../views/settings/personioSettings.vue";
import tariffOverview from "../views/settings/tariff/tariffOverview.vue";
import upgradePayment from "../views/settings/tariff/updatePayment/updatePaymentPage.vue";
import changePlan from "../views/settings/tariff/upgradePlan/upgradeStepper.vue";

//templates
import loginTemplate from "../components/layout/loginTemplate.vue";
import registerTemplate from "../components/layout/registerTemplate.vue";
import verifyRegistration from "../views/login/verifyRegistration.vue";
import generalView from "../components/layout/generalView.vue";
import surveyTemplate from "../views/survey/surveyTemplate.vue";
import multiuserAccept from "../views/multiuserAccept/multiuserAcceptTemplate.vue";
import managedInstruction from "@/views/managedInstruction/managedInstruction.vue";
import managedInstructionAssignmentsTable from "@/views/managedInstruction/managedInstructionAssignmentsTable.vue";
import Examination from "../views/examination/examination.vue";
import ExaminationTable from "../views/examination/examinationTable.vue";
import ExaminationForm from "../views/examination/examinationForm.vue";
import ExaminationEmployeeGroupTable from "../views/examination/employee/employeeGroupTable.vue";
import ExaminationEmployeeGroupForm from "../views/examination/employee/employeeGroupForm.vue";
import ExaminationEmployeeMain from "../views/examination/employee/employeeMain.vue";
import ExaminationAssignmentStatus from "../views/examinationAssignment/examinationAssignmentStatus.vue";
import EmployeeMain from "../views/employee/employeeMain.vue";
import EmployeeTable from "../views/employee/employeeTable.vue";
import EmployeeForm from "../views/employee/employeeForm.vue";
import EmployeeGroupTable from "../views/employee/employeeGroupTable.vue";
import EmployeeGroupForm from "../views/employee/employeeGroupForm.vue";
import IncidentReportFormLong from "../views/incidentReport/incidentReportFormLong.vue";
import EmployeeArchiveTable from "../views/employee/emloyeeArchiveTable.vue";
import EmployeeExternalTable from "../views/employee/employeeExternalTable.vue";
import medkitlogQrCode from "../views/medkitlog/medkitlogQrCode.vue";
import incidentReportQrCode from "../views/incidentReport/incidentReportQrCode.vue";
import riskAssessmentTemplates from "../views/riskAssessment/riskAssessmentTemplates.vue";
import riskAssessmentTemplateList from "../views/riskAssessment/riskAssessmentTemplateList.vue";
import riskAssessmentTemplateForm from "../views/riskAssessment/riskAssessmentTemplateForm.vue";

Vue.use(VueRouter);

/*
        path: "/",
        redirect: "/login/login/1/1",
        component: generalView,
*/

const routes = [
  {
    path: "/newMedkitlog",
    name: "medkitQrCode",
    component: medkitlogQrCode,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/newIncidentReport",
    name: "incidentReportQrCode",
    component: incidentReportQrCode,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/managedInstructionsUserPage/:managedInstructionAssignmentId/:assignmentId/:employeeId",
    name: "managedInstructionsUserPage",
    component: managedInstructionsUserPage,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/examinationAssignment/employee/:assignmentId/:employeeId/status",
    name: "examinationAssignmentUserPage",
    component: ExaminationAssignmentStatus,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/login/:mode/:id/:redirect/:reason/",
    name: "Login",
    component: loginTemplate,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/survey/:mode",
    component: surveyTemplate,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/verify-registration/:token",
    component: verifyRegistration,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/multiuserAccept/:id/:email",
    component: multiuserAccept,
    meta: {
      authNeeded: true,
    },
  },
  {
    path: "/register",
    alias: "/register/survey",
    component: registerTemplate,
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/",
    redirect: "/login/login/1/1/1",
    component: generalView,
    children: [
      {
        path: "/app/tickets/:mode",
        name: "tickets",
        component: tickets,
        meta: {
          authNeeded: true,
          fluid: true,
        },
      },
      {
        path: "/app/instructions",
        name: "instructionsAll",
        component: instructions,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionsHub",
        name: "instructionsHub",
        component: instructionsHub,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionFolder",
        name: "instructionFolder",
        component: instructionFolder,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionFolder/edit/:id/:mode/",
        name: "instructionFolderForm",
        component: instructionFolderForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionFolder/:instructionFolderId/:instructionFolderName",
        name: "instructions",
        props: true,
        component: instructions,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/proofCategory",
        name: "proofCategory",
        component: proofCategory,
        meta: { authNeeded: true },
      },
      {
        path: "/app/proofCategory/edit/:id/:mode/",
        name: "proofCategoryForm",
        component: proofCategoryForm,
        meta: { authNeeded: true },
      },
      {
        path: "/app/proofCategory/:proofCategoryId/:proofCategoryName",
        name: "proofs",
        props: true,
        component: proofs,
        meta: { authNeeded: true },
      },
      {
        path: "/app/proofCategory/:proofCategoryId/:proofCategoryName/edit/:id/:mode/",
        name: "proofForm",
        props: true,
        component: proofForm,
        meta: { authNeeded: true },
      },
      {
        path: "/app/riskAssessmentTemplates",
        name: "riskAssessmentTemplates",
        component: riskAssessmentTemplates,
      },
      {
        path: "/app/riskAssessmentTemplates/:templateCategoryId/:templateCategoryName",
        name: "riskAssessmentTemplateList",
        component: riskAssessmentTemplateList,
      },
      {
        path: "/app/riskAssessmentTemplate/:id/:mode",
        name: "riskAssessmentTemplateForm",
        component: riskAssessmentTemplateForm,
      },
      {
        path: "/app/managedInstructions",
        component: managedInstruction,
        meta: {
          authNeeded: true,
        },
        children: [
          {
            path: "",
            name: "managedInstructionsTable",
            component: managedInstructionAssignmentsTable,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "assignments",
            redirect: "/app/managedInstructions",
            name: "managedInstructionsAssignments",
            component: managedInstructionAssignmentTable,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "managedInstructionAssignmentTable",
            name: "managedInstructionAssignmentTable",
            component: managedInstructionAssignmentTable,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "managedInstructionAssignmentTable/edit/:id/:mode/",
            name: "managedInstructionAssignmentForm",
            component: managedInstructionAssignmentForm,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "/app/managedInstructions/:instructionId/:instructionName",
            name: "managed-instruction-details",
            component: managedInstructionDetailsPage,
            props: true,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employee",
            redirect: "employee/employeeTable",
            name: "managedInstructionEmployeeMain",
            component: employeeMain,
            meta: {
              authNeeded: true,
            },
            children: [
              {
                path: "employeeTable",
                name: "managedInstructionEmployeeGroupTable",
                component: employeeGroupTable,
                meta: {
                  authNeeded: true,
                },
              },
              {
                path: "employeeTable/edit/:id/:mode/",
                name: "managedInstructionEmployeeGroupForm",
                component: employeeGroupForm,
                meta: {
                  authNeeded: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "/app/examination",
        component: Examination,
        meta: {
          authNeeded: true,
        },
        children: [
          {
            path: "",
            name: "examinationTable",
            component: ExaminationTable,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: ":examinationId/:examinationName",
            name: "examination-details",
            component: examinationDetailsPage,
            props: true,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "examinationTable/edit/:id/:mode/",
            name: "examinationForm",
            component: ExaminationForm,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employee",
            redirect: "employee/employeeTable",
            component: ExaminationEmployeeMain,
            meta: {
              authNeeded: true,
            },
            children: [
              {
                path: "employeeTable",
                name: "examinationEmployeeGroupTable",
                component: ExaminationEmployeeGroupTable,
                meta: {
                  authNeeded: true,
                },
              },
              {
                path: "employeeTable/edit/:id/:mode/",
                name: "examinationEmployeeGroupForm",
                component: ExaminationEmployeeGroupForm,
                meta: {
                  authNeeded: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: "/app/employee",
        redirect: "/app/employee/employeeTable",
        component: EmployeeMain,
        meta: {
          authNeeded: true,
        },
        children: [
          {
            path: "employeeTable",
            component: EmployeeTable,
            name: "employeeTable",
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employeeTable/edit/:id/:mode/",
            name: "employeeForm",
            component: EmployeeForm,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employeeGroupTable",
            name: "employeeGroupTable",
            component: EmployeeGroupTable,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employeeGroupTable/edit/:id/:mode/",
            name: "employeeGroupForm",
            component: EmployeeGroupForm,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employeeArchiveTable",
            name: "employeeArchiveTable",
            component: EmployeeArchiveTable,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "employeeExternalTable",
            name: "employeeExternalTable",
            component: EmployeeExternalTable,
            meta: {
              authNeeded: true,
            },
          },
        ],
      },
      // {
      //   path: "/app/riskAssessment",
      //   name: "riskAssessment",
      //   component: riskAssessment,
      //   meta: {
      //     authNeeded: true,
      //   },
      // },
      // {
      //   path: "/app/riskAssessment/edit/:id/:mode/",
      //   props: true,
      //   name: "riskAssessmentForm",
      //   component: riskAssessmentForm,
      //   meta: {
      //     authNeeded: true,
      //   },
      // },
      {
        path: "/app/riskAssessmentCategory",
        name: "riskAssessmentCategory",
        component: riskAssessmentCategory,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/riskAssessmentCategory/edit/:id/:mode/",
        name: "riskAssessmentCategoryForm",
        component: riskAssessmentCategoryForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/riskAssessmentCategory/:riskAssessmentCategoryId/",
        redirect: "/app/riskAssessmentCategory/",
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/riskAssessment/:riskAssessmentCategoryId/",
        name: "riskAssessmentCategoryForm",
        component: riskAssessment,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/riskAssessmentCategory/:riskAssessmentCategoryId/:riskAssessmentCategoryName",
        name: "riskAssessment",
        props: true,
        component: riskAssessment,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/riskAssessmentCategory/:riskAssessmentCategoryId/:riskAssessmentCategoryName/edit/:id/:mode/",
        name: "riskAssessmentForm",
        component: riskAssessmentForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/dangerousGoods",
        name: "dangerousGoods",
        component: DangerousGoodsStorageLocation,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/dangerousGoods/edit/:id/:mode/",
        props: true,
        name: "dangerousGoodsStorageLocationForm",
        component: DangerousGoodsStorageLocationForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/dangerousGoods/:storageLocationId/",
        redirect: "/app/dangerousGoods/",
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/dangerousGoods/:storageLocationId/:storageLocationName",
        props: true,
        name: "dangerousGoodsList",
        component: DangerousGoodsList,
        meta: {
          authNeeded: true,
          fluid: true,
        },
      },
      {
        path: "/app/dangerousGoods/:storageLocationId/:storageLocationName/edit/:id/:mode/",
        props: true,
        name: "dangerousGoodsListForm",
        component: DangerousGoodsListForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionCategory",
        name: "instructionCategory",
        component: instructionCategory,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionCategory/edit/:id/:mode/",
        name: "instructionCategoryForm",
        component: instructionCategoryForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionCategory/:instructionCategoryId/",
        redirect: "/app/instructionCategory/",
        meta: {
          authNeeded: true,
        },
      },
      // {
      //   path: "/app/operatingInstructions/:instructionCategoryId/",
      //   name: "instructionCategoryForm",
      //   component: operatingInstruction,
      //   meta: {
      //     authNeeded: true,
      //   },
      // },
      {
        path: "/app/instructionCategory/:instructionCategoryId/:instructionCategoryName",
        name: "operatingInstruction",
        props: true,
        component: operatingInstruction,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/instructionCategory/:instructionCategoryId/:instructionCategoryName/betriebsanweisung/:id/:mode",
        name: "betriebsanweisungForm",
        props: true,
        component: betriebsanweisungForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/betriebsanweisungTemplates",
        name: "betriebsanweisungTemplates",
        component: betriebsanweisungTemplates,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/betriebsanweisungTemplates/:templateCategoryId/:templateCategoryName",
        name: "betriebsanweisungTemplateList",
        component: betriebsanweisungTemplateList,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/betriebsanweisungTemplate/:id/:mode",
        name: "betriebsanweisungTemplateForm",
        props: true,
        component: betriebsanweisungForm,
        meta: {
          authNeeded: true,
        },
      },
      // {
      //   path: "/app/instructionCategory/:instructionCategoryId/:instructionCategoryName/edit/:id/:mode/",
      //   name: "operatingInstructionForm",
      //   component: operatingInstructionForm,
      //   meta: {
      //     authNeeded: true,
      //   },
      // },
      {
        path: "/app/inspectionCategory",
        name: "inspectionCategory",
        component: inspectionCategory,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/inspectionCategory/edit/:id/:mode/",
        name: "inspectionCategoryForm",
        component: inspectionCategoryForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/inspectionCategory/:inspectionCategoryId/:inspectionCategoryName",
        name: "inspections",
        props: true,
        component: inspection,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/inspectionCategory/:inspectionCategoryId/:inspectionCategoryName/edit/:id/:mode/",
        props: true,
        name: "inspectionForm",
        component: inspectionForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/reports",
        name: "reportsHub",
        component: reportsHub,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/incidentReports",
        name: "incidentReport",
        redirect: { name: "reportsHub", query: { tab: "incidentReport" } },
      },
      {
        path: "/app/incidentReports/year/:year",
        name: "incidentReportMonths",
        props: true,
        component: incidentReportMonths,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/incidentReports/year/:year/month/:month",
        name: "incidentReportByMonth",
        props: true,
        component: incidentReport,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/incidentReports/long/edit/:id/:mode/",
        props: true,
        name: "incidentReportFormLong",
        component: IncidentReportFormLong,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/incidentReports/short/edit/:id/:mode/",
        props: true,
        name: "incidentReportForm",
        component: incidentReportForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/incidentReports/quick/edit/:id/:mode/",
        props: true,
        name: "incidentReportFormQuick",
        component: incidentReportFormQuick,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/asaMeetings",
        name: "asaMeetingYears",
        component: asaMeetingYears,
        meta: { authNeeded: true },
      },
      {
        path: "/app/asaMeetings/year/:year",
        name: "asaMeetingList",
        props: true,
        component: asaMeetingList,
        meta: { authNeeded: true },
      },
      {
        path: "/app/asaMeeting/:id/:mode",
        name: "asaMeetingForm",
        props: true,
        component: asaMeetingForm,
        meta: { authNeeded: true },
      },
      {
        path: "/app/medkitlogs",
        name: "medkitlog",
        redirect: { name: "reportsHub", query: { tab: "medkitlog" } },
      },
      {
        path: "/app/medkitlogs/year/:year",
        name: "medkitlogMonths",
        props: true,
        component: medkitlogMonths,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/medkitlogs/year/:year/month/:month",
        name: "medkitlogByMonth",
        props: true,
        component: medkitlog,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/medkitlogs/edit/:id/:mode/",
        props: true,
        name: "medkitlogForm",
        component: medkitlogForm,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/environmentalReports",
        name: "environmentalReport",
        redirect: {
          name: "reportsHub",
          query: { tab: "environmentalReport" },
        },
      },
      {
        path: "/app/environmentalReports/year/:year",
        name: "environmentalReportMonths",
        props: true,
        component: environmentalReportMonths,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/environmentalReports/year/:year/month/:month",
        name: "environmentalReportByMonth",
        props: true,
        component: environmentalReportByMonthView,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/environmentalReports/edit/:id/:mode/",
        props: true,
        name: "environmentalReportForm",
        component: environmentalReportForm,
        meta: {
          authNeeded: true,
        },
      },
      // {
      //   path: "/qrcode/medkitlogs/edit/:id/:mode/:key",
      //   // path: "/qrcode/medkitlogs/edit/1/new/:key",
      //   props: true,
      //   name: "medkitQrCode",
      //   component: medkitQrCode,
      //   meta: {
      //     authNeeded: false,
      //   },
      // },
      {
        path: "/app/files",
        name: "files",
        component: files,
        meta: {
          authNeeded: true,
        },
        beforeEnter: (to, from, next) => {
          if (isLegacyReadOnly() || !canView("documents")) {
            next({ path: "/app/tickets/all" });
            return;
          }
          next();
        },
      },
      {
        path: "/app/consulting",
        name: "consulting",
        component: consultingPage,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/upgradePayment",
        name: "upgradePayment",
        component: upgradePayment,
        meta: {
          authNeeded: true,
        },
      },
      {
        path: "/app/settings",
        redirect: "/app/settings/boards",
        component: settingsTabs,
        meta: {
          authNeeded: true,
        },
        children: [
          {
            path: "profile",
            name: "profileSettings",
            component: profileSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "boards",
            name: "boardSettings",
            component: boardSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "email",
            name: "emailSettings",
            component: emailSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "multiuser",
            name: "multiuserSettings",
            component: multiuserSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "proofers",
            name: "proofersSettings",
            component: proofersSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "incidentReport",
            name: "incidentReportSettings",
            component: incidentReportSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "tariff",
            name: "tariffOverview",
            component: tariffOverview,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "integrations",
            name: "personioSettings",
            component: personioSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "users",
            name: "usersSettings",
            component: usersSettings,
            meta: {
              authNeeded: true,
            },
          },
          {
            path: "usersSettings/edit/:id/:mode/",
            props: true,
            name: "usersForm",
            component: usersForm,
            meta: {
              authNeeded: true,
            },
          },
        ],
      },
      {
        path: "/app/changePlan/:step/:portalData/:selected",
        props: true,
        name: "changePlan",
        component: changePlan,
        meta: {
          authNeeded: true,
        },
      },
    ],
  },
  {
    path: "/instruction",
    name: "instruction-public",
    component: instructionPublic,
    props: (route) => ({ token: route.query.id || "" }),
    meta: {
      authNeeded: false,
    },
  },
  {
    path: "/managedInstructions/:instructionId/preview",
    name: "managedInstructionPreview",
    component: instructionPublic,
    props: (route) => ({
      previewInstructionId: route.params.instructionId,
      previewType: route.query.type || "",
    }),
    meta: {
      authNeeded: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function ensureUserData() {
  if (localStorage.getItem("userData")) return Promise.resolve();
  return axios
    .get("info", { headers: { Authorization: getTokenFromLocalStorage() } })
    .then((r) => localStorage.setItem("userData", JSON.stringify(r.data)))
    .catch(() => {});
}

//navigation guard
router.beforeEach((to, from, next) => {
  //check if auth is needed
  if (to.meta.authNeeded) {
    //needed
    isAuthenticated().then(async (r) => {
      if (!r) {
        //remove token from localstorage
        removeDataFromLocalStorage();
        next({
          name: "Login",
          params: {
            mode: "login",
            id: 1,
            redirect: encodeURIComponent(
              window.location.origin + window.location.pathname,
            ),
            reason: "isAuthenticated",
          },
        });
        next();
      } else {
        if (to.path.startsWith("/app/tickets")) {
          await ensureUserData();
          if (!canView("tickets")) return next(homePath());
        }
        next();
      }
    });
  } else {
    //not needed
    next();
  }
});

export default router;
